module.exports = __webpack_public_path__ + "static/media/workers.0a85b59d.png";